module.exports = __webpack_public_path__ + "img/en_US.a2c556f.jpg";